module.exports = __webpack_public_path__ + "img/Toll.b5ddbeb7.png";